import { render, staticRenderFns } from "./DateCalendar.vue?vue&type=template&id=4756a8f6&scoped=true"
import script from "./DateCalendar.vue?vue&type=script&lang=js"
export * from "./DateCalendar.vue?vue&type=script&lang=js"
import style0 from "./DateCalendar.vue?vue&type=style&index=0&id=4756a8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4756a8f6",
  null
  
)

export default component.exports